module.exports = __webpack_public_path__ + "static/media/explosions.d.ts.8a712b13.map";